import { DashboardMenuOption } from '../../components/dashboard-menu/constants'
import React from 'react'
import { TemplateLibraryComponent } from './component'

export const routes = [
  {
    action: () => <TemplateLibraryComponent />,
    path: DashboardMenuOption.templateLibrary,
  }
]